import React from 'react';
import { connect } from 'react-redux';
import Stopper from '@/components/stopper/Stopper';
import { createBrowserHistory } from "history";
import { actions as initActions } from '@/reducers/initPage';
import { push2DataLayerError } from '@/utils/commonUtils';

const filePath = `ErrorBoundary-${process.env.NEXT_PUBLIC_PROJECT_ID}`;
const processName = 'APP-CONTROLLER';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      prevLocation: '/area-cliente/mis-productos',
      currentLocation: null,
      errorInfo: null,
    };
  }


  
  componentDidMount(){
    const history = createBrowserHistory();
    history.listen(({location}) => {
    const { pathname } = location;
    const { currentLocation, prevLocation, errorInfo } = this.state; 
    if (currentLocation !== prevLocation){
      this.setState({
        currentLocation: pathname,
        prevLocation: currentLocation,
      })
      if (errorInfo) {
        window.location.reload();
      }
    }
    
  });
  }


  componentDidCatch = (error) => {
    this.setState({ errorInfo: error }, () => {
      this.props.setError(-69);
      this.sendMonitoringInfo(error, this.props.context);
    });
  };


  shouldComponentUpdate() {
    return true;
  }

  sendMonitoringInfo = (error, context) => {
    console.log({error})
    const pageInfo = location;
    let actualPageName = null;
    if (pageInfo) {
      actualPageName = pageInfo.href;
      const info = {
        msg: error.toString(),
        page: actualPageName,
        status: 'KO',
      };
      if (pageInfo && actualPageName && info.msg) {
        push2DataLayerError('error', info.msg, actualPageName);
        import('@gcloud-npm/utils.monitoring.front-sonda').then((frontSondaModule) => {
          const sonda = new frontSondaModule.default({
            processName: 'ErrorBoundary',
            context,
            filePath: 'MainContent',
          });
          sonda.errorMessage({error});
        })
      }
    }
  };

  render() {
    if (!this.state.errorInfo) {
      return this.props.children;
    }

    return <Stopper handlingCode={-69} />;
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (error) => dispatch(initActions.setError(error)),
  };
};

const mapStateToProps = (state) => ({
  error: state.initPage?.handlingCode,
  // placeWhereError: state.errorCatcher.placeWhereError,
  context: state.main.context,
});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);